import { useContext } from 'react';

import { Button, ButtonGroup } from '@blueprintjs/core';
import PageContext from '../../Context/PageContext';

const ImgController = () => {

  const { objItems, selectedItem, setCropImage, cropImage } = useContext(PageContext);

  function setRound() {
    /* To set changed property to listItems*/
    const item = objItems.find(item => item.id === selectedItem.id);

    if (selectedItem != null) {
      if (selectedItem.querySelector('img').style.borderRadius == '50%') {
        selectedItem.querySelector('img').style.borderRadius = '0';
        item.style['border-radius'] = '0';
      }
      else {
        selectedItem.querySelector('img').style.borderRadius = '50%';
        item.style['border-radius'] = '50%';
      }
    }
  }

  function showCrop() {
    /* To set changed property to listItems*/
    const item = objItems.find(item => item.id === selectedItem.id);

    if(setCropImage != null) {setCropImage(item)}
  }

  return (
    <div className="img-controller">
      <ButtonGroup>
        {/*<Button className='' onClick={() => setRound()} icon="circle" ></Button>*/}
        <Button className='' onClick={() => showCrop()} icon="crop"></Button>
      </ButtonGroup>
    </div>
  );
};

export default ImgController;